import gql from 'graphql-tag'

export const ADD_TAGS = gql`
mutation(
	$name:[String]
	$jobFunctionId:ID!
){
	addSearchTags(info:{name:$name jobFunctionId:$jobFunctionId})
}
`
export const TAG_LIST = gql`
query (
	$page:Int
	$perPage:Int
	$search:String
){
	getAllSearchTags (
		page:$page perPage:$perPage search:$search
	){
		info{
			_id
		  name
			jobFunctionId{
				_id 
				name
			}
		}
		total	
	}
}

`
export const DELETE_TAGS = gql`
mutation (
	$_id: ID!
) {
	deleteSearchTags(_id: $_id)
}
`
export const EDIT_TAGS = gql`
query (
	$_id:ID
){
	getSearchTags (_id:$_id){
		_id
		name
		jobFunctionId{
			_id
			name
		}
	}
}

`
export const UPDATE_TAGS = gql`
mutation(
	$_id:ID!
	$name:[String]
	$jobFunctionId:ID!
){
	updateSearchTags(info:{
		_id:$_id 
		name:$name 
		jobFunctionId:$jobFunctionId
	})
}

`